(function ($, window, document, undefined) {
	"use strict";

	var pluginName = 'argonmenu',
		defaults = {
			resizeWidth: 767,
			initiallyVisible: false,
			collapserTitle: 'Main Menu',
			animSpeed: 'medium',
			easingEffect: null,
			indentChildren: false,
			childrenIndenter: '&nbsp;&nbsp;',
			expandIcon: '<i>&#9660;</i>',
			collapseIcon: '<i>&#9650;</i>'
		};

	function Plugin(element, options) {
		this.element = element;
		this.$menu = $(element);
		this.options = $.extend({}, defaults, options);
		this.oldWindowWidth = 0;
		this.$collapser = null;

		this.init();
	}

	Plugin.prototype = {

		/* ------------------------------------
		   Init
		------------------------------------ */

		init: function () {
			var self = this,
				opts = this.options,
				$window = $(window);

			// Build menu collapser (per instance)
			this.$collapser = $(
				'<div class="menu-collapser">' +
					'<div class="collapse-button">' +
						'<div class="hamburger">' +
							'<span></span><span></span><span></span>' +
						'</div>' +
						opts.collapserTitle +
					'</div>' +
				'</div>'
			);

			this.$menu.before(this.$collapser);

			// Submenu toggle (mobile icon)
			this.$menu.on('click', '.sub-toggle', function (e) {
				e.preventDefault();
				e.stopPropagation();

				var $toggle = $(this);
				var $li = $toggle.closest('li');

				if ($toggle.hasClass('expanded')) {
					$toggle.removeClass('expanded').html(opts.expandIcon);
					$li.children('ul').slideUp(opts.animSpeed, opts.easingEffect);
				} else {
					$toggle.addClass('expanded').html(opts.collapseIcon);
					$li.children('ul').slideDown(opts.animSpeed, opts.easingEffect);
				}
			});

			// Main menu toggle
			this.$collapser.on('click', '.collapse-button', function (e) {
				e.preventDefault();

				self.$menu.not(':animated').slideToggle(
					opts.animSpeed,
					opts.easingEffect,
					function () {
						self.$collapser.toggleClass('open');
					}
				);
			});

			// Touch support
			this.bindTouchHandlers();

			// Initial state + resize
			this.resizeMenu();
			$window.on('resize.argonmenu', function () {
				self.resizeMenu();
			});
		},

		/* ------------------------------------
		   Resize logic
		------------------------------------ */

		resizeMenu: function () {
			var self = this,
				opts = this.options,
				$window = $(window),
				windowWidth = $window.width();

			if (window.innerWidth && window.innerWidth > windowWidth) {
				windowWidth = window.innerWidth;
			}

			if (windowWidth === this.oldWindowWidth) return;
			this.oldWindowWidth = windowWidth;

			// Reset submenu state
			this.$menu.find('li').each(function () {
				var $li = $(this);

				if ($li.children('ul').length) {
					$li.addClass('has-submenu');

					if (!$li.children('.sub-toggle').length) {
						$li.append('<span class="sub-toggle">' + opts.expandIcon + '</span>');
					} else {
						$li.children('.sub-toggle')
							.removeClass('expanded')
							.html(opts.expandIcon);
					}
				}

				$li.children('ul').hide();
				$li.removeClass('touch-open');
			});

			this.$collapser.removeClass('open');

			// Mobile
			if (windowWidth <= opts.resizeWidth) {

				if (opts.indentChildren) {
					this.$menu.find('ul').each(function () {
						var depth = $(this).parents('ul').length;
						$(this).children('li').children('a').each(function () {
							if (!$(this).children('i').length) {
								$(this).prepend(self.indent(depth, opts));
							}
						});
					});
				}

				this.$menu
					.addClass('collapsed')
					.find('li')
					.off('mouseenter mouseleave');

				this.$collapser.show();

				if (!opts.initiallyVisible) {
					this.$menu.hide();
				}

			// Desktop
			} else {

				this.$menu.find('li').has('ul')
					.on('mouseenter', function () {
						$(this).children('ul')
							.stop()
							.slideDown(opts.animSpeed, opts.easingEffect);
					})
					.on('mouseleave', function () {
						$(this).children('ul')
							.stop()
							.slideUp(opts.animSpeed, opts.easingEffect);
					});

				this.$menu
					.find('li > a > i')
					.remove();

				this.$menu
					.removeClass('collapsed')
					.show();

				this.$collapser.hide();
			}
		},

		/* ------------------------------------
		   Touch support
		------------------------------------ */

		isTouch: function () {
			return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
		},

		bindTouchHandlers: function () {
			var self = this;
			if (!this.isTouch()) return;

			this.$menu.on('click', 'li.has-submenu > a', function (e) {
				var $li = $(this).parent();

				// First tap: open submenu
				if (!$li.hasClass('touch-open')) {
					e.preventDefault();

					self.$menu.find('li.touch-open')
						.removeClass('touch-open')
						.children('ul')
						.slideUp(self.options.animSpeed);

					$li.addClass('touch-open')
						.children('ul')
						.slideDown(self.options.animSpeed);
				}
				// Second tap: allow navigation
			});
		},

		/* ------------------------------------
		   Helpers
		------------------------------------ */

		indent: function (num, opts) {
			var indent = '';
			for (var i = 0; i < num; i++) {
				indent += opts.childrenIndenter;
			}
			return '<i>' + indent + '</i> ';
		}
	};

	/* ------------------------------------
	   jQuery plugin wrapper
	------------------------------------ */

	$.fn[pluginName] = function (options) {
		return this.each(function () {
			if (!$.data(this, 'plugin_' + pluginName)) {
				$.data(this, 'plugin_' + pluginName, new Plugin(this, options));
			}
		});
	};

}(jQuery, window, document));